<header class="astrea-menu-navbar">

    <div class="astrea-toolbar d-flex j-c-around a-i-center">

        <div class="d-flex j-c-center a-i-center">
            <a routerLink="/" class="hide-mobile" title="Ir a la home">
                <img class="py-1" height="84px" src="../../../../assets/images/logos/av_logo_white.svg" alt="{{ 'logo' | translate }}">
            </a>
            <a routerLink="/" class="hide-desktop" title="Ir a la home">
                <img height="52px" src="../../../../assets/images/logos/av_logo_white.svg" alt="{{ 'logo' | translate }}">
            </a>
        </div>

        <div class="hide-mobile">
            <div class="d-flex">
                <a routerLink="/searcher" title="{{ 'navigation.search' | translate }}" class="mx-2">
                    {{ 'navigation.search' | translate }}
                </a>
                <a routerLink="/catalog" title="{{ 'navigation.catalog' | translate }}" class="mx-2">
                    {{ 'navigation.catalog' | translate }}
                </a>
                <a routerLink="/about" class="infoLink" title="{{ 'about.title' | translate }}" class="mx-2">
                    {{ 'about.title' | translate }}
                </a>
                <a routerLink="/pricing" class="infoLink" title="{{ 'footer.pricing' | translate }}" class="mx-2">
                    {{ 'footer.pricing' | translate }}
                </a>
                <a routerLink="/contact" class="infoLink" title="{{ 'footer.contact' | translate }}" class="mx-2">
                    {{ 'footer.contact' | translate }}
                </a>

                <span *ngIf="(isLoggedIn$ | async)" class="logged-pipe">
                    |
                </span>

                <a *ngIf="(isLoggedIn$ | async) && !isUserShared" routerLink="/library" title="{{ 'navigation.library' | translate }}" class="mx-2">
                    {{ 'navigation.library' | translate }}
                </a>
                <a *ngIf="(isLoggedIn$ | async) && isUserAdmin" routerLink="/cpanel" title="{{ 'navigation.administrator' | translate }}" class="mx-2">
                    {{ 'navigation.administrator' | translate }}
                </a>
            </div>
        </div>


        <div class="d-flex j-c-end a-i-center">

            <div class="astrea-language">
                <select (ngModelChange)="handleLanguage()" name="language" [(ngModel)]="language">
                    <option value="es-ar">ES</option>
                    <option value="en-us">EN</option>
                </select>
            </div>

            <div class="hide-mobile">
                <div *ngIf="(isLoggedIn$ | async); else navBarLogout" >
                    <button class="avDropdown d-flex j-c-center a-i-center ml-3 w-100" [matMenuTriggerFor]="avDropdown">
                        <span mat-icon-button>
                            <mat-icon>persona</mat-icon>
                        </span>
                        <span>{{ isUserShared ? ('navigation.menu' | translate) : userName }}</span>
                    </button>
                    <mat-menu #avDropdown="matMenu">
                        <div class="astrea-profile-dropdown d-flex j-c-between a-i-start flex-wrap flex-column">
                            <mat-nav-list class="w-100">
                                <a routerLink="profile/personal" title="{{ 'navigation.profile' | translate }}" mat-menu-item>
                                    <mat-icon class="mr-2" attr.aria-label="{{ 'navigation.profile' | translate }}">account_circle</mat-icon>
                                    {{ 'navigation.profile' | translate }}
                                </a>
                                <a *ngIf="!isUserShared" routerLink="history/searches" title="{{ 'navigation.history' | translate }}" mat-menu-item>
                                    <mat-icon class="mr-2" attr.aria-label="{{ 'navigation.history' | translate }}">history</mat-icon>
                                    {{ 'navigation.history' | translate }}
                                </a>
                                <a *ngIf="!isUserShared" routerLink="/subs" title="{{ 'navigation.subs' | translate }}" mat-menu-item>
                                    <mat-icon class="mr-2" attr.aria-label="{{ 'navigation.subs' | translate }}">star</mat-icon>
                                    {{ 'navigation.subs' | translate }}
                                </a>
                                <a routerLink="/contact" title="{{ 'navigation.contact' | translate }}" mat-menu-item>
                                    <mat-icon class="mr-2" attr.aria-label="{{ 'navigation.contact' | translate }}">feedback</mat-icon>
                                    {{ 'navigation.contact' | translate }}
                                </a>
                            </mat-nav-list>
                            <a (click)="logout()" (keydown.enter)="logout()" class="btn-logout" title="{{ 'navigation.logout' | translate }}" mat-menu-item>
                                {{ 'navigation.logout' | translate }}
                            </a>
                        </div>
                    </mat-menu>
                </div>
            </div>

            <ng-template #navBarLogout>
                <div class="navBarLogout2 d-flex j-c-center a-i-center">
                    <a [routerLink]="['/register']" [queryParams]="{ redirect: redirect }" title="{{ 'navigation.register' | translate }}">
                        {{ 'navigation.register' | translate }}
                    </a>
                    <a [routerLink]="['/login']" [queryParams]="{ redirect: redirect }" class="mr-3" title="{{ 'navigation.login' | translate }}">
                        {{ 'navigation.login' | translate }}
                    </a>
                </div>
            </ng-template>

        </div>

        <div class="hide-desktop">
            <button (click)="handleMenuClose()" class="d-flex j-c-center" mat-icon-button>
                <mat-icon>menu</mat-icon>
            </button>
        </div>

    </div>
</header>
